"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FPCTPageThree;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _DisclosureModal = _interopRequireDefault(require("../Wizard/DisclosureModal"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _CalculatePlan = require("./CalculatePlan");
var _FinancialPlanningCheckupWizardTool = require("./FinancialPlanningCheckupWizardTool.config");
var _FPCTModals = require("./FPCTModals");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function FPCTPageThree(_ref) {
  var {
    disclosureHandleClose,
    showDisclosure,
    onlyShowAnalysis = false
  } = _ref;
  // Auto-focus to snap scrolling to top of the stepper/progress bar if user travels back-and-forth between steps
  (0, _react.useEffect)(() => {
    document.getElementById(_FinancialPlanningCheckupWizardTool.calcName).scrollIntoView();
    if (window) {
      window.scrollBy(0, -112);
    }
  }, []);
  var {
    values,
    setFieldValue
  } = (0, _formik.useFormikContext)();

  // Solutions state modals handlers - To manage the open/close state of each modal
  var [investmentSolutionsRetirementModalOpen, setInvestmentSolutionsRetirementModalOpen] = (0, _react.useState)(false);
  var setInvestmentSolutionsRetirementModalClose = () => {
    setInvestmentSolutionsRetirementModalOpen(false);
  };
  var [investmentSolutionsMajorPurchaseModalOpen, setInvestmentSolutionsMajorPurchaseModalOpen] = (0, _react.useState)(false);
  var setInvestmentSolutionsMajorPurchaseModalClose = () => {
    setInvestmentSolutionsMajorPurchaseModalOpen(false);
  };
  var [investmentSolutionsWealthModalOpen, setInvestmentSolutionsWealthModalOpen] = (0, _react.useState)(false);
  var setInvestmentSolutionsWealthModalClose = () => {
    setInvestmentSolutionsWealthModalOpen(false);
  };
  var [investmentSolutionsEducationModalOpen, setInvestmentSolutionsEducationModalOpen] = (0, _react.useState)(false);
  var setInvestmentSolutionsEducationModalClose = () => {
    setInvestmentSolutionsEducationModalOpen(false);
  };
  var [retirementAccountsRetirementModalOpen, setRetirementAccountsRetirementModalOpen] = (0, _react.useState)(false);
  var setRetirementAccountsRetirementModalClose = () => {
    setRetirementAccountsRetirementModalOpen(false);
  };
  var [retirementAccountsWealthModalOpen, setRetirementAccountsWealthModalOpen] = (0, _react.useState)(false);
  var setRetirementAccountsWealthModalClose = () => {
    setRetirementAccountsWealthModalOpen(false);
  };
  var [annuitiesRetirementModalOpen, setAnnuitiesRetirementModalOpen] = (0, _react.useState)(false);
  var setAnnuitiesRetirementModalClose = () => {
    setAnnuitiesRetirementModalOpen(false);
  };
  var [annuitiesWealthModalOpen, setAnnuitiesWealthModalOpen] = (0, _react.useState)(false);
  var setAnnuitiesWealthModalClose = () => {
    setAnnuitiesWealthModalOpen(false);
  };
  var [annuitiesFamilySecuredModalOpen, setAnnuitiesFamilySecuredModalOpen] = (0, _react.useState)(false);
  var setAnnuitiesFamilySecuredModalClose = () => {
    setAnnuitiesFamilySecuredModalOpen(false);
  };
  var [lifeInsuranceRetirementModalOpen, setLifeInsuranceRetirementModalOpen] = (0, _react.useState)(false);
  var setLifeInsuranceRetirementModalClose = () => {
    setLifeInsuranceRetirementModalOpen(false);
  };
  var [lifeInsuranceTransitioningWealthModalOpen, setLifeInsuranceTransitioningWealthModalOpen] = (0, _react.useState)(false);
  var setLifeInsuranceTransitioningWealthModalClose = () => {
    setLifeInsuranceTransitioningWealthModalOpen(false);
  };
  var [lifeInsuranceEducationModalOpen, setLifeInsuranceEducationModalOpen] = (0, _react.useState)(false);
  var setLifeInsuranceEducationModalClose = () => {
    setLifeInsuranceEducationModalOpen(false);
  };
  var [lifeInsuranceFamilySecuredModalOpen, setLifeInsuranceFamilySecuredModalOpen] = (0, _react.useState)(false);
  var setLifeInsuranceFamilySecuredModalClose = () => {
    setLifeInsuranceFamilySecuredModalOpen(false);
  };
  var [longTermCareRetirementModalOpen, setLongTermCareRetirementModalOpen] = (0, _react.useState)(false);
  var setLongTermCareRetirementModalClose = () => {
    setLongTermCareRetirementModalOpen(false);
  };
  var [longTermCareFamilySecuredModalOpen, setLongTermCareFamilySecuredModalOpen] = (0, _react.useState)(false);
  var setLongTermCareFamilySecuredModalClose = () => {
    setLongTermCareFamilySecuredModalOpen(false);
  };
  var [hsaSavingsAccountsModalOpen, setHsaSavingsAccountsModalOpen] = (0, _react.useState)(false);
  var setHsaSavingsAccountsModalClose = () => {
    setHsaSavingsAccountsModalOpen(false);
  };
  var [taxPlanningStrategiesRetirementModalOpen, setTaxPlanningStrategiesRetirementModalOpen] = (0, _react.useState)(false);
  var setTaxPlanningStrategiesRetirementModalClose = () => {
    setTaxPlanningStrategiesRetirementModalOpen(false);
  };
  var [taxPlanningStrategiesWealthModalOpen, setTaxPlanningStrategiesWealthModalOpen] = (0, _react.useState)(false);
  var setTaxPlanningStrategiesWealthModalClose = () => {
    setTaxPlanningStrategiesWealthModalOpen(false);
  };
  var [estatePlanningServicesWealthModalOpen, setEstatePlanningServicesWealthModalOpen] = (0, _react.useState)(false);
  var setEstatePlanningServicesWealthModalClose = () => {
    setEstatePlanningServicesWealthModalOpen(false);
  };
  var [estatePlanningServicesFamilySecuredModalOpen, setEstatePlanningServicesFamilySecuredModalOpen] = (0, _react.useState)(false);
  var setEstatePlanningServicesFamilySecuredModalClose = () => {
    setEstatePlanningServicesFamilySecuredModalOpen(false);
  };
  var [trustServicesWealthModalOpen, setTrustServicesWealthModalOpen] = (0, _react.useState)(false);
  var setTrustServicesWealthModalClose = () => {
    setTrustServicesWealthModalOpen(false);
  };
  var [trustServicesFamilySecuredModalOpen, setTrustServicesFamilySecuredModalOpen] = (0, _react.useState)(false);
  var setTrustServicesFamilySecuredModalClose = () => {
    setTrustServicesFamilySecuredModalOpen(false);
  };
  var [savingsAccountModalOpen, setSavingsAccountModalOpen] = (0, _react.useState)(false);
  var setSavingsAccountModalClose = () => {
    setSavingsAccountModalOpen(false);
  };
  var [otherInvestmentsModalOpen, setOtherInvestmentsModalOpen] = (0, _react.useState)(false);
  var setOtherInvestmentsModalClose = () => {
    setOtherInvestmentsModalOpen(false);
  };
  var [educationalSavingsModalOpen, setEducationalSavingsModalOpen] = (0, _react.useState)(false);
  var setEducationalSavingsModalClose = () => {
    setEducationalSavingsModalOpen(false);
  };
  var [disabilityInsuranceModalOpen, setDisabilityInsuranceModalOpen] = (0, _react.useState)(false);
  var setDisabilityInsuranceModalClose = () => {
    setDisabilityInsuranceModalOpen(false);
  };

  /* modalHandlers is an object that groups all the modal state handlers together to make it easier to pass them around as a single object.
   It maps the state variables and functions to keys that can be used to access them, giving us centralized access. */
  var modalHandlers = {
    investmentSolutionsRetirement: setInvestmentSolutionsRetirementModalOpen,
    investmentSolutionsRetirementClose: setInvestmentSolutionsRetirementModalClose,
    investmentSolutionsRetirementOpen: investmentSolutionsRetirementModalOpen,
    investmentSolutionsMajorPurchase: setInvestmentSolutionsMajorPurchaseModalOpen,
    investmentSolutionsMajorPurchaseClose: setInvestmentSolutionsMajorPurchaseModalClose,
    investmentSolutionsMajorPurchaseOpen: investmentSolutionsMajorPurchaseModalOpen,
    investmentSolutionsWealth: setInvestmentSolutionsWealthModalOpen,
    investmentSolutionsWealthClose: setInvestmentSolutionsWealthModalClose,
    investmentSolutionsWealthOpen: investmentSolutionsWealthModalOpen,
    investmentSolutionsEducation: setInvestmentSolutionsEducationModalOpen,
    investmentSolutionsEducationClose: setInvestmentSolutionsEducationModalClose,
    investmentSolutionsEducationOpen: investmentSolutionsEducationModalOpen,
    retirementAccountsRetirement: setRetirementAccountsRetirementModalOpen,
    retirementAccountsRetirementClose: setRetirementAccountsRetirementModalClose,
    retirementAccountsRetirementOpen: retirementAccountsRetirementModalOpen,
    retirementAccountsWealth: setRetirementAccountsWealthModalOpen,
    retirementAccountsWealthClose: setRetirementAccountsWealthModalClose,
    retirementAccountsWealthOpen: retirementAccountsWealthModalOpen,
    annuitiesRetirement: setAnnuitiesRetirementModalOpen,
    annuitiesRetirementClose: setAnnuitiesRetirementModalClose,
    annuitiesRetirementOpen: annuitiesRetirementModalOpen,
    annuitiesWealth: setAnnuitiesWealthModalOpen,
    annuitiesWealthClose: setAnnuitiesWealthModalClose,
    annuitiesWealthOpen: annuitiesWealthModalOpen,
    annuitiesFamilySecured: setAnnuitiesFamilySecuredModalOpen,
    annuitiesFamilySecuredClose: setAnnuitiesFamilySecuredModalClose,
    annuitiesFamilySecuredOpen: annuitiesFamilySecuredModalOpen,
    lifeInsuranceRetirement: setLifeInsuranceRetirementModalOpen,
    lifeInsuranceRetirementClose: setLifeInsuranceRetirementModalClose,
    lifeInsuranceRetirementOpen: lifeInsuranceRetirementModalOpen,
    lifeInsuranceTransitioningWealth: setLifeInsuranceTransitioningWealthModalOpen,
    lifeInsuranceTransitioningWealthClose: setLifeInsuranceTransitioningWealthModalClose,
    lifeInsuranceTransitioningWealthOpen: lifeInsuranceTransitioningWealthModalOpen,
    lifeInsuranceEducation: setLifeInsuranceEducationModalOpen,
    lifeInsuranceEducationClose: setLifeInsuranceEducationModalClose,
    lifeInsuranceEducationOpen: lifeInsuranceEducationModalOpen,
    lifeInsuranceFamilySecured: setLifeInsuranceFamilySecuredModalOpen,
    lifeInsuranceFamilySecuredClose: setLifeInsuranceFamilySecuredModalClose,
    lifeInsuranceFamilySecuredOpen: lifeInsuranceFamilySecuredModalOpen,
    longTermCareRetirement: setLongTermCareRetirementModalOpen,
    longTermCareRetirementClose: setLongTermCareRetirementModalClose,
    longTermCareRetirementOpen: longTermCareRetirementModalOpen,
    longTermCareFamilySecured: setLongTermCareFamilySecuredModalOpen,
    longTermCareFamilySecuredClose: setLongTermCareFamilySecuredModalClose,
    longTermCareFamilySecuredOpen: longTermCareFamilySecuredModalOpen,
    hsaSavingsAccounts: setHsaSavingsAccountsModalOpen,
    hsaSavingsAccountsClose: setHsaSavingsAccountsModalClose,
    hsaSavingsAccountsOpen: hsaSavingsAccountsModalOpen,
    taxPlanningStrategiesRetirement: setTaxPlanningStrategiesRetirementModalOpen,
    taxPlanningStrategiesRetirementClose: setTaxPlanningStrategiesRetirementModalClose,
    taxPlanningStrategiesRetirementOpen: taxPlanningStrategiesRetirementModalOpen,
    taxPlanningStrategiesWealth: setTaxPlanningStrategiesWealthModalOpen,
    taxPlanningStrategiesWealthClose: setTaxPlanningStrategiesWealthModalClose,
    taxPlanningStrategiesWealthOpen: taxPlanningStrategiesWealthModalOpen,
    estatePlanningServicesWealth: setEstatePlanningServicesWealthModalOpen,
    estatePlanningServicesWealthClose: setEstatePlanningServicesWealthModalClose,
    estatePlanningServicesWealthOpen: estatePlanningServicesWealthModalOpen,
    estatePlanningServicesFamilySecured: setEstatePlanningServicesFamilySecuredModalOpen,
    estatePlanningServicesFamilySecuredClose: setEstatePlanningServicesFamilySecuredModalClose,
    estatePlanningServicesFamilySecuredOpen: estatePlanningServicesFamilySecuredModalOpen,
    trustServicesWealth: setTrustServicesWealthModalOpen,
    trustServicesWealthClose: setTrustServicesWealthModalClose,
    trustServicesWealthOpen: trustServicesWealthModalOpen,
    trustServicesFamilySecured: setTrustServicesFamilySecuredModalOpen,
    trustServicesFamilySecuredClose: setTrustServicesFamilySecuredModalClose,
    trustServicesFamilySecuredOpen: trustServicesFamilySecuredModalOpen,
    savingsAccount: setSavingsAccountModalOpen,
    savingsAccountClose: setSavingsAccountModalClose,
    savingsAccountOpen: savingsAccountModalOpen,
    otherInvestments: setOtherInvestmentsModalOpen,
    otherInvestmentsClose: setOtherInvestmentsModalClose,
    otherInvestmentsOpen: otherInvestmentsModalOpen,
    educationalSavings: setEducationalSavingsModalOpen,
    educationalSavingsClose: setEducationalSavingsModalClose,
    educationalSavingsOpen: educationalSavingsModalOpen,
    disabilityInsurance: setDisabilityInsuranceModalOpen,
    disabilityInsuranceClose: setDisabilityInsuranceModalClose,
    disabilityInsuranceOpen: disabilityInsuranceModalOpen
  };
  var disclosureArray = ['This interactive calculator is a self-help tool and is not intended to provide financial advice or product recommendations. The results and explanations generated by this calculator are based upon, and will vary due to, your input and certain assumptions made by us. MassMutual will assume no liability for the use of or reliance on this calculator. For a more accurate and detailed analysis specific to your circumstances, we encourage you to contact a qualified financial professional.', 'The information provided is not written or intended as specific tax or legal advice. MassMutual, its employees and representatives are not authorized to give tax or legal advice. Individuals are encouraged to seek advice from their own tax or legal counsel.', 'Insurance products issued by Massachusetts Mutual Life Insurance Company (MassMutual) and its subsidiaries, C.M. Life Insurance Company (C. M. Life) and MML Bay State Life Insurance Company (MML Bay State), Springfield, MA 01111-0001. C.M. Life and MML Bay State are non-admitted in New York.', 'Securities and advisory services offered through MML Investors Services, LLC Member SIPC and a MassMutual subsidiary.'];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !onlyShowAnalysis && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h4", null, "Analysis"), /*#__PURE__*/_react.default.createElement("p", null, "Goals often change at various stages of life. This is why a comprehensive approach and specialized guidance from a trusted partner can contribute to successful long-term planning and help secure your financial future."), /*#__PURE__*/_react.default.createElement("div", {
    className: "pathContainer mm-spacing--minor"
  }, /*#__PURE__*/_react.default.createElement(_CalculatePlan.CalculatePlanMessage, {
    values: values,
    setFieldValue: setFieldValue
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "analysisContainer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-6"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    className: "no-box-shadow"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-text-center"
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Your current plan")), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement(_CalculatePlan.CalculatePlan, {
    values: values,
    setFieldValue: setFieldValue,
    columnType: "current"
  }), /*#__PURE__*/_react.default.createElement("hr", null)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-6"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    variant: "flat"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-text-center"
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Plan considerations")), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement(_CalculatePlan.CalculatePlan, {
    values: values,
    setFieldValue: setFieldValue,
    setModalOpen: modalHandlers,
    columnType: "optimized"
  })))))), /*#__PURE__*/_react.default.createElement(_FPCTModals.InvestmentSolutionsModalForRetirement, {
    handleClose: setInvestmentSolutionsRetirementModalClose,
    show: investmentSolutionsRetirementModalOpen
  }), /*#__PURE__*/_react.default.createElement(_FPCTModals.InvestmentSolutionsModalForMajorPurchase, {
    handleClose: setInvestmentSolutionsMajorPurchaseModalClose,
    show: investmentSolutionsMajorPurchaseModalOpen
  }), /*#__PURE__*/_react.default.createElement(_FPCTModals.InvestmentSolutionsModalForWealth, {
    handleClose: setInvestmentSolutionsWealthModalClose,
    show: investmentSolutionsWealthModalOpen
  }), /*#__PURE__*/_react.default.createElement(_FPCTModals.InvestmentSolutionsModalForEducation, {
    handleClose: setInvestmentSolutionsEducationModalClose,
    show: investmentSolutionsEducationModalOpen
  }), /*#__PURE__*/_react.default.createElement(_FPCTModals.RetirementAccountsModalForRetirement, {
    handleClose: setRetirementAccountsRetirementModalClose,
    show: retirementAccountsRetirementModalOpen
  }), /*#__PURE__*/_react.default.createElement(_FPCTModals.RetirementAccountsModalForWealth, {
    handleClose: setRetirementAccountsWealthModalClose,
    show: retirementAccountsWealthModalOpen
  }), /*#__PURE__*/_react.default.createElement(_FPCTModals.AnnuitiesModalForRetirement, {
    handleClose: setAnnuitiesRetirementModalClose,
    show: annuitiesRetirementModalOpen
  }), /*#__PURE__*/_react.default.createElement(_FPCTModals.AnnuitiesModalForWealth, {
    handleClose: setAnnuitiesWealthModalClose,
    show: annuitiesWealthModalOpen
  }), /*#__PURE__*/_react.default.createElement(_FPCTModals.AnnuitiesModalForFamilySecured, {
    handleClose: setAnnuitiesFamilySecuredModalClose,
    show: annuitiesFamilySecuredModalOpen
  }), /*#__PURE__*/_react.default.createElement(_FPCTModals.LifeInsuranceModalForRetirement, {
    handleClose: setLifeInsuranceRetirementModalClose,
    show: lifeInsuranceRetirementModalOpen
  }), /*#__PURE__*/_react.default.createElement(_FPCTModals.LifeInsuranceModalForTransitioningWealth, {
    handleClose: setLifeInsuranceTransitioningWealthModalClose,
    show: lifeInsuranceTransitioningWealthModalOpen
  }), /*#__PURE__*/_react.default.createElement(_FPCTModals.LifeInsuranceModalForEducation, {
    handleClose: setLifeInsuranceEducationModalClose,
    show: lifeInsuranceEducationModalOpen
  }), /*#__PURE__*/_react.default.createElement(_FPCTModals.LifeInsuranceModalForFamilySecured, {
    handleClose: setLifeInsuranceFamilySecuredModalClose,
    show: lifeInsuranceFamilySecuredModalOpen
  }), /*#__PURE__*/_react.default.createElement(_FPCTModals.LongTermCareProtectionModalForRetirement, {
    handleClose: setLongTermCareRetirementModalClose,
    show: longTermCareRetirementModalOpen
  }), /*#__PURE__*/_react.default.createElement(_FPCTModals.LongTermCareProtectionModalForFamilySecured, {
    handleClose: setLongTermCareFamilySecuredModalClose,
    show: longTermCareFamilySecuredModalOpen
  }), /*#__PURE__*/_react.default.createElement(_FPCTModals.HsaSavingsAccountsModal, {
    handleClose: setHsaSavingsAccountsModalClose,
    show: hsaSavingsAccountsModalOpen
  }), /*#__PURE__*/_react.default.createElement(_FPCTModals.TaxPlanningStrategiesModalForRetirement, {
    handleClose: setTaxPlanningStrategiesRetirementModalClose,
    show: taxPlanningStrategiesRetirementModalOpen
  }), /*#__PURE__*/_react.default.createElement(_FPCTModals.TaxPlanningStrategiesModalForWealth, {
    handleClose: setTaxPlanningStrategiesWealthModalClose,
    show: taxPlanningStrategiesWealthModalOpen
  }), /*#__PURE__*/_react.default.createElement(_FPCTModals.EstatePlanningServicesModalForWealth, {
    handleClose: setEstatePlanningServicesWealthModalClose,
    show: estatePlanningServicesWealthModalOpen
  }), /*#__PURE__*/_react.default.createElement(_FPCTModals.EstatePlanningServicesModalForFamilySecured, {
    handleClose: setEstatePlanningServicesFamilySecuredModalClose,
    show: estatePlanningServicesFamilySecuredModalOpen
  }), /*#__PURE__*/_react.default.createElement(_FPCTModals.TrustServicesModalForWealth, {
    handleClose: setTrustServicesWealthModalClose,
    show: trustServicesWealthModalOpen
  }), /*#__PURE__*/_react.default.createElement(_FPCTModals.TrustServicesModalForFamilySecured, {
    handleClose: setTrustServicesFamilySecuredModalClose,
    show: trustServicesFamilySecuredModalOpen
  }), /*#__PURE__*/_react.default.createElement(_FPCTModals.SavingsAccountModal, {
    handleClose: setSavingsAccountModalClose,
    show: savingsAccountModalOpen
  }), /*#__PURE__*/_react.default.createElement(_FPCTModals.OtherInvestmentstModal, {
    handleClose: setOtherInvestmentsModalClose,
    show: otherInvestmentsModalOpen
  }), /*#__PURE__*/_react.default.createElement(_FPCTModals.EducationalSavingsModal, {
    handleClose: setEducationalSavingsModalClose,
    show: educationalSavingsModalOpen
  }), /*#__PURE__*/_react.default.createElement(_FPCTModals.DisabilityInsuranceModal, {
    handleClose: setDisabilityInsuranceModalClose,
    show: disabilityInsuranceModalOpen
  }), !onlyShowAnalysis && /*#__PURE__*/_react.default.createElement(_DisclosureModal.default, {
    textArray: disclosureArray,
    handleClose: disclosureHandleClose,
    show: showDisclosure
  }));
}